import axios from "axios";
//import {browserHistory} from "react-router";

//const
const EQUIPMENT_LOG_UPDATE_DATA = "equipmentLog/EQUIPMENT_LOG_UPDATE_DATA";
const EQUIPMENT_CONFIG_STORE_LOG_TYPES = "equipmentLog/EQUIPMENT_CONFIG_STORE_LOG_TYPES";
const EQUIPMENT_LOG_STORE_EQUIPMENT = "equipmentLog/EQUIPMENT_LOG_STORE_EQUIPMENT";
const EQUIPMENT_LOG_STORE_EQUIPMENT_LOGS = "equipmentLog/EQUIPMENT_LOG_STORE_EQUIPMENT_LOGS";
const EQUIPMENT_LOG_TOGGLE_MODAL = "equipmentLog/EQUIPMENT_LOG_TOGGLE_MODAL";
const EQUIPMENT_LOG_TOGGLE_LOADING = "equipmentLog/EQUIPMENT_LOG_TOGGLE_LOADING";

//reducer
export const equipmentLog = (state = {

  loading: false,

  equipmentId: "",
  logTypes: [],
  rangeDate: [],
  rangeDateString: [],
  types: [],
  equipmentLogs: [],

}, action) => {
  switch (action.type) {
    case EQUIPMENT_LOG_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_CONFIG_STORE_LOG_TYPES:
      return {
        ...state,
        logTypes: action.data
      };
    case EQUIPMENT_LOG_STORE_EQUIPMENT:
      return {
        ...state,
        equipmentId: action.data,
        rangeDate: [],
        rangeDateString: [],
        types: [],
      };
    case EQUIPMENT_LOG_STORE_EQUIPMENT_LOGS:
      return {
        ...state,
        equipmentLogs: action.data,
      };
    case EQUIPMENT_LOG_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};
/**
 * update data based
 */
export const updateEquipmentLogData = (data) => {
  return {
    type: EQUIPMENT_LOG_UPDATE_DATA,
    data: data
  }
};

/**
 * init equipment types
 */
export const initEquipmentLog = (equipmentId) => (dispatch) => {
  dispatch(toggleLoading(true));
  if (equipmentId !== null && equipmentId !== undefined && equipmentId !== "") {
    dispatch(storeEquipment(equipmentId));
    axios({
      method: "POST",
      url: "/api-equipment/findEquipmentLog",
      contentType: "application/json",
      withCredentials: true,
      data: {
        "guid": equipmentId,
        "type": "",
        "beginDate": "",
        "endDate": ""
      },
    }).then(
      response => {
        dispatch(toggleLoading(false));
        if (response.status === 200) {
          console.info("success query equipment logs");
          dispatch(storeEquipmentLogs(response.data));
        }
        else {
          console.error("fail to query equipment logs");
          dispatch(storeEquipmentLogs([]));
        }
      }
    );
  } else {
    dispatch(toggleLoading(false));
    this.props.history.push("/exception/415");
  }
};

/**
 * store all equipment logs
 */
export const storeEquipment = (equipment) => {
  return {
    type: EQUIPMENT_LOG_STORE_EQUIPMENT,
    data: equipment
  }
};

/**
 * get all log types
 */
export const getLogTypes = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-equipment/getLogTypes", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeLogTypes(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all log types
 */
export const storeLogTypes = (logTypes) => {
  return {
    type: EQUIPMENT_CONFIG_STORE_LOG_TYPES,
    data: logTypes
  }
};

/**
 * search equipment logs
 */
export const searchEquipmentLogs = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "POST",
    url: "/api-equipment/findEquipmentLog",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "guid": data.equipmentId,
      "type": data.types,
      "beginDate": data.beginDate,
      "endDate": data.endDate
    },
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success search equipment logs");
        dispatch(storeEquipmentLogs(response.data));
      }
      else {
        console.error("fail to search equipment logs");
        dispatch(storeEquipmentLogs([]));
      }
    }
  );
};

/**
 * store show equipment types
 */
export const storeEquipmentLogs = (equipmentLogs) => {
  return {
    type: EQUIPMENT_LOG_STORE_EQUIPMENT_LOGS,
    data: equipmentLogs
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_LOG_TOGGLE_LOADING,
    data: show
  }
};

